import PropTypes from 'prop-types';
import React from 'react';
import './preview_modal.scss';

class PreviewModal extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string,
    isMobile: PropTypes.bool,
    remove: PropTypes.func,
    mediaTag: PropTypes.string,
  };

  render() {
    const { src, remove, isMobile, mediaTag } = this.props;
    return (
      <div className={`image-preview-container ${isMobile ? 'is-mobile' : ''}`}>
        {mediaTag === 'img' && <img src={src} alt={src} />}
        {mediaTag === 'video'
          && <video src={src} controls autoPlay disablePictureInPicture controlsList="nodownload" />}
        <button type="button" className="image-preview-close" onClick={remove}>
          <img
            className="image-preview-icon-close"
            src="https://m.xiguacity.cn/gutenberg/icons/modal-close.svg"
            alt="关闭"
          />
        </button>
      </div>
    );
  }
}


export default PreviewModal;
